import { createSlice } from "@reduxjs/toolkit";

export const shiftListSlider = createSlice({
  name: "shiftListSlider",
  initialState: {
    shiftList: [],
    shiftTimeData: {
      shiftStartDateTime: "",
      shiftEndDateTime: "",
      shiftStartTime: "",
      shiftEndTime: "",
    },
    pickerTimeData: {
      selectedStartDateTime: "",
      selectedEndDateTime: "",
      selectedStartTime: "",
      selectedEndTime: "",
    },
  },
  reducers: {
    setShiftList: (state, action) => {
      state.shiftList = [...action.payload];
    },

    setShiftTimeData: (state, action) => {
      const {
        shiftStartDateTime,
        shiftEndDateTime,
        shiftStartTime,
        shiftEndTime,
      } = action.payload;

      state.shiftTimeData = {
        ...state.shiftTimeData,
        shiftStartDateTime: shiftStartDateTime,
      };
      state.shiftTimeData = {
        ...state.shiftTimeData,
        shiftEndDateTime: shiftEndDateTime,
      };
      state.shiftTimeData = {
        ...state.shiftTimeData,
        shiftStartTime: shiftStartTime,
      };
      state.shiftTimeData = {
        ...state.shiftTimeData,
        shiftEndTime: shiftEndTime,
      };

      // state.value -= 1
    },

    setPickerTimeData: (state, action) => {
      const {
        selectedStartDateTime,
        selectedEndDateTime,
        selectedStartTime,
        selectedEndTime,
      } = action.payload;

      state.pickerTimeData = {
        ...state.pickerTimeData,
        selectedStartDateTime: selectedStartDateTime,
      };
      state.pickerTimeData = {
        ...state.pickerTimeData,
        selectedEndDateTime: selectedEndDateTime,
      };
      state.pickerTimeData = {
        ...state.pickerTimeData,
        selectedStartTime: selectedStartTime,
      };
      state.pickerTimeData = {
        ...state.pickerTimeData,
        selectedEndTime: selectedEndTime,
      };

      // state.value -= 1
    },
    incrementByAmount: (state, action) => {
      // state.value += action.payload
    },
  },
});

// Action creators are generated for each case reducer function
export const { setShiftList, setShiftTimeData, setPickerTimeData } =
  shiftListSlider.actions;

export default shiftListSlider.reducer;

// export default  counterReducer  = counterSlice.reducer
